module.exports = __webpack_public_path__ + "static/media/Sharp-ePoster-Product-Page.62a48766.jpg";